import React from 'react';

export const compileNumberOfContributions = (data, values) => {
  if (!data || !Array.isArray(values)) return 0;
  return values.reduce((total, value) => {
    const count =
      (data[`${value}Count12mo`] ?? 0) +
      (data[`${value}Count3mo`] ?? 0) +
      (data[`${value}Count1mo`] ?? 0) +
      (data[`${value}Count1w`] ?? 0);
    return total + count;
  }, 0);
};

export const getContributionsText = (data, values, featureName, additionalText = '') => {
  const finalNumber = compileNumberOfContributions(data, values);
  if (finalNumber === 0) return '';
  const plural = finalNumber > 1 ? 's' : '';
  const suffix = additionalText ? `${additionalText} in the last 12 months` : 'in the last 12 months';
  return `${finalNumber} relevant ${featureName}${plural} ${suffix}`;
};

export const createNumbers = (data, values, iconClassName, featureName, additionalText = '') => {
  const text = getContributionsText(data, values, featureName, additionalText);
  const showIcon = iconClassName != null && iconClassName !== false;
  return (
    <>
      {text && (
        <li>
          {showIcon && <span className={`paragraph-p5 icon-${iconClassName}`} />}
          {text}
        </li>
      )}
    </>
  );
};
